import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { apiFetch } from '../utils/apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

function ForgotPassword() {
  const location = useLocation();
  const [email, setEmail] = useState(() => location.state?.email || '');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const response = await apiFetch(`${API_BASE_URL}/auth/password-reset/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'Unable to request a password reset');
      setMessage(data.message);
      setEmail('');
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="public-page">
      <div className="login-section">
        <div className="login-container">
          <div className="login-card">
            <h1 className="login-title">Reset Your Password</h1>
            <p className="login-subtitle">Enter your account email and we will send password-reset instructions if the account is eligible.</p>
            {message && <div className="admin-quality-success" role="status">{message}</div>}
            {error && <div className="login-error" role="alert">{error}</div>}
            {!message && (
              <form className="login-form" onSubmit={handleSubmit}>
                <div className="login-form-group">
                  <label className="login-label" htmlFor="password-reset-email">Email</label>
                  <input id="password-reset-email" className="login-input" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} />
                </div>
                <button className="login-button" type="submit" disabled={loading}>{loading ? 'Sending…' : 'Send Reset Link'}</button>
              </form>
            )}
            <div className="login-footer">
              <p className="login-footer-text"><Link className="login-signup-link" to="/login">Back to sign in</Link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
